import { useEffect } from "react";
import { useFollowers } from "../hooks/useFollow";
import { useNotify } from "../hooks/NotifyProvider";
import {
  Avatar,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  CircularProgress,
} from "@mui/material";

export const Follower = ({ userId }) => {
  const { data: followers = [], isLoading, isError } = useFollowers(userId);
  const { notify } = useNotify();

  useEffect(() => {
    if (isError) notify("Failed to loading.", "error");
  }, [isError, notify]);

  const handleClick = (selectedHandle) => {
    const newUrl = `${window.location.origin}/${selectedHandle}`;
    window.open(newUrl, "_blank");
  };
  return (
    <div>
      {isLoading ? (
        <div className="flex justify-center items-center ">
          <CircularProgress />
        </div>
      ) : (
        <>
          {followers.length !== 0 ? (
            <List sx={{ width: "100%" }}>
              {followers.map((follower) => (
                <ListItem
                  key={follower.id}
                  onClick={() => {
                    handleClick(
                      follower.follower.handle && follower.follower.handle
                    );
                  }}
                  sx={{
                    cursor: "pointer",
                    "&:hover": {
                      bgcolor: "action.hover",
                      textDecoration: "none",
                      borderRadius: 2,
                      "& *": {
                        textDecoration: "none",
                      },
                    },
                  }}
                >
                  <ListItemAvatar>
                    <Avatar
                      src={
                        follower.follower.picture && follower.follower.picture
                      }
                    />
                  </ListItemAvatar>
                  <ListItemText
                    primary={follower.follower.name}
                    secondary={`@${follower.follower.handle}`}
                  />
                </ListItem>
              ))}
            </List>
          ) : (
            <div className="font-soft flex justify-center">No followers</div>
          )}
        </>
      )}
    </div>
  );
};
